import PropTypes from 'prop-types';
import React from 'react';
import { Container, Center, Text, GridItem } from '@chakra-ui/react';

import { DeptGrid } from '@rsc/ui-components/dept/design-system';
import useConvertToObjectArray from '@rsc/ui-components/dept/utils/useConvertToObjectArray';
import Image from '@rsc/ui-components/tailwind/Image';
import Link from '@rsc/ui-components/tailwind/Link';
import SocialLinksMessage from '../../../atoms/SocialLinksMessage';

function UGCGrid({ block, socialMedia }) {
  const socialData = useConvertToObjectArray(socialMedia);

  if (!block?.media) return null;

  const { title, media } = block;

  return (
    <Container as={Center} flexDirection="column" my={10} gap={6}>
      <Text textStyle="h1" textAlign="center">
        {title}
      </Text>
      <SocialLinksMessage data={socialData} />
      <DeptGrid w="full">
        {media.map(item => (
          <GridItem
            key={item._key}
            colSpan={item.featured ? 6 : 3}
            rowSpan={item.featured ? 2 : 1}
            as={item.link ? Link : 'div'}
            link={item.link}
          >
            <Image
              className={item.featured ? 'featured' : ''}
              sanityImage={item.image}
              srcSetBasisWidth={item.featured ? 1000 : 700}
            />
          </GridItem>
        ))}
      </DeptGrid>
    </Container>
  );
}

UGCGrid.propTypes = {
  block: PropTypes.shape({
    title: PropTypes.string,
    media: PropTypes.arrayOf(
      PropTypes.shape({
        featured: PropTypes.bool,
        image: PropTypes.shape({
          asset: PropTypes.shape({
            url: PropTypes.string,
          }),
          alt: PropTypes.string,
        }),
      })
    ),
  }).isRequired,
  socialMedia: PropTypes.shape({
    facebookBool: PropTypes.bool,
    facebookUrl: PropTypes.string,
    instagramBool: PropTypes.bool,
    instagramUrl: PropTypes.string,
    youtubeBool: PropTypes.bool,
    youtubeUrl: PropTypes.string,
    twitterBool: PropTypes.bool,
    twitterUrl: PropTypes.string,
    pinterestBool: PropTypes.bool,
    pinterestUrl: PropTypes.string,
    tiktokBool: PropTypes.bool,
    tiktokUrl: PropTypes.string,
  }).isRequired,
};

export default UGCGrid;
